<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import "./common/icon/iconfont.css";
.ivu-select-large.ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder,
.ivu-select-large.ivu-select-single
  .ivu-select-selection
  .ivu-select-selected-value {
  text-align: left;
  text-indent: 6px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue